import {Component, Inject, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-unsubscribe-confirmation',
    templateUrl: './unsubscribe-confirmation.component.html',
    styleUrls: ['./unsubscribe-confirmation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UnsubscribeConfirmationComponent {
  dealInfo: any;

  constructor(
    private dialogRef: MatDialogRef<UnsubscribeConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) data: {
      dealInfo: any
    }
  ) {
    this.dealInfo = data ? data.dealInfo : '';
    dialogRef.disableClose = true;
  }
}
